import o, { useState as m } from "react";
import { useTranslation as I } from "react-i18next";
import { Modal as P } from "../../../../common/components/Modal/Modal.js";
import { PhoneInput as v } from "../../../../common/components/forms/PhoneInput/PhoneInput.js";
import r from "./phoneInputForm.module.scss.js";
function L({
  show: p,
  onClose: l,
  onBack: f,
  onSubmit: n,
  design: t,
  errorMessage: c,
  dismissOnBackdrop: u,
  dismissOnEscape: b,
  showBackButton: C = !0
}) {
  const { t: a } = I(), [y, h] = m(""), [x, B] = m(!1), E = (e, k, F) => {
    h(k), B(F);
  }, N = {
    "--pif-text-color": (t == null ? void 0 : t.textColor) ?? "#fff",
    "--pif-primary-btn-bg": (t == null ? void 0 : t.primaryButtonBackgroundColor) ?? "#f8b233",
    "--pif-primary-btn-text": (t == null ? void 0 : t.primaryButtonTextColor) ?? "#fff",
    "--pif-secondary-btn-bg": (t == null ? void 0 : t.secondaryButtonBackgroundColor) ?? "#cabed3",
    "--pif-secondary-btn-text": (t == null ? void 0 : t.secondaryButtonTextColor) ?? "#302e3a"
  };
  return /* @__PURE__ */ o.createElement(
    P,
    {
      show: p,
      showCloseBtn: !1,
      onClose: l,
      dismissOnBackdrop: u,
      dismissOnEscape: b,
      design: {
        backgroundColor: (t == null ? void 0 : t.backgroundColor) ?? "#302e3a",
        textColor: (t == null ? void 0 : t.textColor) ?? "#fff",
        fontFamily: t == null ? void 0 : t.fontFamily
      }
    },
    /* @__PURE__ */ o.createElement(
      "div",
      {
        className: r.container,
        style: N,
        onMouseDown: (e) => e.stopPropagation(),
        onClick: (e) => e.stopPropagation()
      },
      /* @__PURE__ */ o.createElement("div", { className: r.title }, a("phoneInputForm.title")),
      /* @__PURE__ */ o.createElement("div", { className: r.content }, /* @__PURE__ */ o.createElement(
        v,
        {
          label: a("phoneInputForm.phoneLabel"),
          design: {
            textColor: (t == null ? void 0 : t.textColor) ?? "#fff",
            borderColor: (t == null ? void 0 : t.textColor) ?? "#fff"
          },
          onChange: E
        }
      )),
      c && /* @__PURE__ */ o.createElement("div", { className: r.error }, c),
      /* @__PURE__ */ o.createElement("div", { className: r.buttons }, C && /* @__PURE__ */ o.createElement(
        "button",
        {
          className: r.secondaryButton,
          type: "button",
          onClick: f ?? l
        },
        a("phoneInputForm.back")
      ), /* @__PURE__ */ o.createElement(
        "button",
        {
          className: r.primaryButton,
          type: "button",
          disabled: !x,
          onClick: () => n(y)
        },
        a("phoneInputForm.continue")
      ))
    )
  );
}
export {
  L as PhoneInputForm
};
//# sourceMappingURL=PhoneInputForm.js.map
